
import React from 'react';
import { InfoIcon } from 'lucide-react';
import { 
  Tooltip, 
  TooltipContent, 
  TooltipProvider, 
  TooltipTrigger 
} from '@/components/ui/tooltip';

export const ChartHeader: React.FC = () => {
  return (
    <div className="flex items-center justify-between">
      <h3 className="text-sm font-medium text-hormony-charcoal">Hormone Fluctuation Chart</h3>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="cursor-help">
              <InfoIcon size={16} className="text-hormony-charcoal/60" />
            </div>
          </TooltipTrigger>
          <TooltipContent className="max-w-xs">
            <p>This chart shows how your hormones fluctuate throughout your menstrual cycle.</p>
            <p className="mt-1 text-xs text-hormony-charcoal/70">
              Hover over data points for exact values. The colored regions represent different cycle phases.
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
